module.exports = __webpack_public_path__ + "avab.862426a3f2c35092907e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/avab.ttf
// module id = ./src/assets/webfonts/avab.ttf
// module chunks = styles